import * as React from 'react';

import { useScheduleBoardModals } from 'af-root/hooks/useScheduleBoardModal';

import ImageAttachmentPreviewModal from 'af-components/DocumentsAttachmentsTree/Modals/ImageAttachmentPreviewModal';

interface OwnProps {
	onCloseImagePreviewAttachmentModal: () => void;
}

const NonActionModals: React.FC<OwnProps> = (props) => {

	const {
		imageAttachmentSrc,
		showImageAttachmentPreviewModal,
	} = useScheduleBoardModals();

	const {
		onCloseImagePreviewAttachmentModal,
	} = props;

	return (
		<ImageAttachmentPreviewModal
			attachmentSrc={imageAttachmentSrc}
			onCloseModal={onCloseImagePreviewAttachmentModal}
			showModal={showImageAttachmentPreviewModal}
		/>
	);
};

export default React.memo(NonActionModals);
